<!--Translated-->
<template>
  <div
    class="tablepreview"
    ref="tooltip"
    :style="`opacity: ${visible ? 1 : 0};`"
  >
    <div
      v-if="visible"
      class="tablepreview_textblock tablepreview_textblock--list"
    >
      <h4 @click="goToProductPage" style="cursor: pointer">
        {{ product.name }}
      </h4>
      <p>
        <span>{{ $t('HoverTooltipProduct:Manufacturer') }} - </span>
        <span>{{ manufacturerName }}</span>
      </p>
      <p>
        <span>{{ $t('HoverTooltipProduct:Country') }} - </span>
        <span> {{ countryName.trim() }} </span>
      </p>
      <p v-if="!noSubstance">
        <span>{{ $t('HoverTooltipProduct:Substance') }} - </span>
        <span>{{ product.active_substance || '...' }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import routeNames from '@/router/routeNames';

export default {
  name: 'UserHoverTooltipProductDefence',
  props: {
    product: { type: Object, required: true },
    noSubstance: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState({
      manufacturer(state) {
        return state.userDefence.manufacturers.find(
          ({ id }) => id === this.product.manufacturer_id
        );
      },
      countryName(state) {
        return this.manufacturer
          ? state.userDefence.manufacturersCountries.find(
              ({ id }) => id === this.manufacturer.id
            )?.name ?? '...'
          : '...';
      },
    }),
    manufacturerName() {
      return this.manufacturer?.name ?? '...';
    },
  },
  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      this.visible = entries[0].isIntersecting;
    });
    this.observer.observe(this.$refs.tooltip);
  },
  beforeDestroy() {
    this.observer?.unobserve(this.$refs.tooltip);
  },
  methods: {
    goToProductPage() {
      if (this.noSubstance) return;
      const routeData = this.$router.resolve({
        name: routeNames.editProduct,
        params: { id: this.product.id },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>
